import { toastError, toastSuccess } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext';
import { useAuth } from '@hooks/useAuth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

export const useDeleteTemplate = () => {
	const { session } = useAuth();
	const queryClient = useQueryClient();
	const { selectedProfile } = useBankProfile();
	const { t } = useTranslation('', { keyPrefix: 'templatesList.confirmRemove' });

	const handleDeleteTemplate = async (templateId: string) => {
		const { data } = await axios.delete(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/payment-templates/${templateId}`,
			{
				headers: {
					Authorization: session?.tokenized,
				},
			},
		);

		return data;
	};

	return useMutation({
		mutationFn: handleDeleteTemplate,
		onSuccess: async () => {
			toastSuccess(t('success'));
			await queryClient.invalidateQueries({
				queryKey: ['templates'],
			});
		},
		onError: (err) => {
			toastError(t('failed'));

			throw err;
		},
	});
};
